const CloudUpload = ({ size = 16, fill = '#036EBC' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9 6.69366C12.4467 4.39366 10.4267 2.66699 8 2.66699C6.07333 2.66699 4.4 3.76033 3.56667 5.36033C1.56 5.57366 0 7.27366 0 9.33366C0 11.5403 1.79333 13.3337 4 13.3337H12.6667C14.5067 13.3337 16 11.8403 16 10.0003C16 8.24032 14.6333 6.81366 12.9 6.69366ZM9.33333 8.66699V11.3337H6.66667V8.66699H4.66667L7.76667 5.56699C7.9 5.43366 8.10667 5.43366 8.24 5.56699L11.3333 8.66699H9.33333Z"
        fill={fill}
      />
    </svg>
  );
};

export default CloudUpload;
